function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFA300",
  d: "M24.5 12.5c0 6.627-5.373 12-12 12-6.628 0-12-5.372-12-12s5.372-12 12-12c6.627 0 12 5.373 12 12zm-1 0c0-6.075-4.926-11-11-11-6.076 0-11 4.925-11 11s4.924 11 11 11c6.074 0 11-4.925 11-11z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFAF20",
  d: "M11 6h2.93l-.491 9.695H11.49L11 6zm1.509 14a1.37 1.37 0 0 1-1.08-.494c-.286-.329-.429-.73-.429-1.204s.146-.876.439-1.205c.292-.329.649-.493 1.07-.493.41 0 .76.168 1.052.503.293.336.439.734.439 1.195 0 .474-.146.875-.439 1.204-.292.33-.643.494-1.052.494z"
}));

var SvgAlertIcon = function SvgAlertIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlertIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/alert_icon.a3ce2d10.svg";
export { ForwardRef as ReactComponent };